/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CreateContractReviewerResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'ContractReviewer',
        isRequired: true,
      },
    },
  }],
} as const;
